import Vibrant from './config'
import BrowserImage from '@vibrant/image-browser'

Vibrant.DefaultOpts.ImageClass = BrowserImage

export = Vibrant
